"use client"
/* */
function ListSearch(ignoredProps) {
  return null;
}
const TypedListSearch = () => ListSearch;

export { ListSearch, TypedListSearch };
//# sourceMappingURL=ListSearch.mjs.map
